import {Trans, useTranslation} from 'react-i18next'
import {ConfirmIcon} from '@/assets/icons/icons'
import {StyledConfirmIcon, StyledOption, StyledOptionText} from './style'
import {HostPartialTypeV3} from '@/features/authentication/types'
import {ChannelsType, RepresentedHostsType} from '@/features/representative/types'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useMe} from '@/features/authentication/queries/useMe'
import {UserRoleE} from '@/types'

type ChatHostOptionProps = {
    onClick: () => void
    host: (HostPartialTypeV3 & {hostChannels?: ChannelsType}) | RepresentedHostsType
    selectedHostId?: number
    count: number
}

export const ChatHostOption = ({onClick, host, selectedHostId, count = 0}: ChatHostOptionProps) => {
    const {t} = useTranslation()
    const {data: user} = useMe()
    const isRepresentative = user?.type === UserRoleE.Representative
    const isSelectedHost = isRepresentative
        ? selectedHostId === (host as RepresentedHostsType).rookieId
        : selectedHostId === host.id // fix with correct unread message count
    const isLoading = false
    return (
        <StyledOption key={host.id} onClick={onClick}>
            <StyledConfirmIcon checked={isSelectedHost}>
                <ConfirmIcon />
            </StyledConfirmIcon>

            <StyledOptionText>
                <Trans
                    t={t}
                    i18nKey={host && 'creator' in host ? host.creator.username : host?.username}
                    components={{span: <span />}}
                />{' '}
            </StyledOptionText>

            {!isSelectedHost && (
                <StyledOptionText>
                    {count === null || isLoading ? (
                        <Spinner overlay={false} center={false} inline={true} size={8} />
                    ) : (
                        count > 0 && `(${count})`
                    )}
                </StyledOptionText>
            )}
        </StyledOption>
    )
}
